import { render, staticRenderFns } from "./Halo.vue?vue&type=template&id=4a6efb88&"
import script from "./Halo.vue?vue&type=script&lang=js&"
export * from "./Halo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports